import React, { Suspense } from 'react';
import CustomerIdentityHandler from './components/handlers/CustomerIdentityHandler';
import FrontendHandler from './components/handlers/FrontendHandler';

import ConfigHandler from './components/handlers/ConfigHandler';
import DataFetchHandler from './components/handlers/DataFetchHandler';
import ProductBookingConfigHandler from './components/handlers/ProductBookingConfigHandler';
import { Provider } from 'react-redux';
import defaultStore from './store/store';
import { I18nextProvider } from 'react-i18next';

import { StyledEngineProvider } from '@mui/material/styles';
import { SnackbarProvider } from 'notistack';

import ProgressComponent from './components/ProgressBar';
import LanguageHandler from './components/handlers/LanguageHandler';
import OpenReplayHandler from './components/handlers/OpenReplayHandler';

export default function App({
  appConfig = {},
  muiTheme = {},
  fcConfig = {},
  store,
  i18nInstance,
}) {
  const activeStore = store || defaultStore;

  const content = (
    <Provider store={activeStore}>
      <OpenReplayHandler active={window.location.href.includes('rebook')} />
      <ConfigHandler
        muiTheme={muiTheme}
        fcConfig={fcConfig}
        appConfig={appConfig}
      >
        <ProductBookingConfigHandler />
        <DataFetchHandler>
          <LanguageHandler />
          <CustomerIdentityHandler>
            <FrontendHandler />
          </CustomerIdentityHandler>
        </DataFetchHandler>
      </ConfigHandler>
    </Provider>
  );

  return (
    <Suspense
      fallback={
        <ProgressComponent
          visible
          circleSx={{ color: '#777' }}
          wrapperSx={{ height: appConfig?.height ? appConfig?.height : 500 }}
        />
      }
    >
      <StyledEngineProvider injectFirst>
        <SnackbarProvider
          maxSnack={3}
          autoHideDuration={3000}
          anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
        >
          {i18nInstance ? (
            <I18nextProvider i18n={i18nInstance}>{content}</I18nextProvider>
          ) : (
            content
          )}
        </SnackbarProvider>
      </StyledEngineProvider>
    </Suspense>
  );
}
